import { getRequestCredentials, request } from "@prismicio/editor-support/Http"
import { z } from "zod"

import type { AuthStrategy } from "../../EditorConfig"

const customTypeResponse = z.object({
  id: z.string(),
  label: z.string(),
  repeatable: z.boolean(),
  status: z.boolean()
})

const repositoryCustomTypesResponse = z.array(customTypeResponse)

export type CustomTypeResponse = z.TypeOf<typeof customTypeResponse>

export function getRepositoryCustomTypes(
  baseUrl: URL,
  repository: string,
  authStrategy: AuthStrategy
) {
  return request(new URL("customtypes", baseUrl), {
    headers: {
      repository: repository
    },
    credentials: getRequestCredentials(authStrategy),
    okType: repositoryCustomTypesResponse
  })
}
